import { AIMessageError } from '@components/ArtBoard/AIChat/components/AIChatSidebar/components/ChatMessagesList/components/AIMessageError'
import { ChatMessageItem } from '@components/ArtBoard/AIChat/components/AIChatSidebar/components/ChatMessagesList/components/ChatMessageItem/ChatMessageItem'
import {
  selectAIError,
  selectAIGenerating,
  selectAIHistoryLoading,
  selectAIMessages,
  selectAIStreamingText,
} from '@store/reducers/ai'
import type React from 'react'
import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

import css from '../../styles.module.css'
import { AIMessage } from '..'
import { ChatHistorySkeleton } from './components/ChatHistorySkeleton'

interface ChatMessagesListProps {
  autoScroll?: boolean
}

export const ChatMessagesList: React.FC<ChatMessagesListProps> = ({
  autoScroll = true,
}) => {
  const messagesEndRef = useRef<HTMLDivElement>(null)

  const generating = useSelector(selectAIGenerating)
  const messages = useSelector(selectAIMessages)
  const error = useSelector(selectAIError)
  const historyLoading = useSelector(selectAIHistoryLoading)
  // v2 (chat-agent): text of the message being streamed; always null on v1.
  const streamingText = useSelector(selectAIStreamingText)

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
  }

  useEffect(() => {
    if (autoScroll) {
      scrollToBottom()
    }
  }, [messages, generating, error, streamingText, autoScroll])

  return (
    <div className={css.ai_chat_sidebar_messages}>
      {historyLoading ? (
        <ChatHistorySkeleton />
      ) : (
        <>
          {messages.map((message, index) => (
            <ChatMessageItem
              key={index}
              message={message}
              index={index}
              isLast={index === messages.length - 1}
            />
          ))}

          {generating && (
            <AIMessage isGenerating={generating}>
              {streamingText || null}
            </AIMessage>
          )}

          {error && <AIMessageError />}
        </>
      )}

      <div ref={messagesEndRef} />
    </div>
  )
}
